import { combineReducers } from "redux";
import auth from "./authReducer";
import goals from "./goals";
import users from "./users";
import freeVotes from "./freeVotesReducer";
import tournaments from "./tournaments";
import leaderboard from "./leaderboardReducer";
import loggedUserReducer from "./loggedUserReducer";
import user from "./getUserReducer";
import userGoals from "./userGoals";
import goalComments from "./goalCommentsReducer";
import leaderboardUser from "./userLeaderboards";
import myGoals from "./userOwnGoalsReducer";
import myTournaments from "./userOwnTournamentReducer";
import myClubs from "./userOwnClubReducer";
import myLeagues from "./userOwnLeagueReducer";
import globalSearch from "./globalSearchReducer";
import professionalTournament from "./professionalTournaments";
import banners from "./bannerReducers";
import bannersCategories from "./bannerCategoriesReducer";
import homeBanners from "./homeBannerReducers";
import homeBannerCategories from "./homeBannerCategoriesReducer";
import homeBannerChooser from "./homeBannerChooserReducer";
import competitions from "./competitionsReducer";
import competitionsList from "./competitionsListReducer";
import advertisements from "./advertisementsReducer";
import goalCategories from "./goalCategoriesReducer";
import goalCategoriesAdmin from "./goalCategoriesAdminReducer";
import notifications from "./notificationReducer";
import youtubeLinks from "./youtubeLinksReducer";
import carousel from "./bannerCarouselReducer";
import features from "./featuresReducer";
import userVote from "./userVoteState";
import allClubs from "../features/allClubs.slice";
import allAdminClub from "../features/admin/allClubs.slice";
import allAdminLeague from "../features/admin/allLeagues.slice";

const appReducer = combineReducers({
  auth,
  goals,
  users,
  tournaments,
  leaderboard,
  freeVotes,
  loggedUser: loggedUserReducer,
  user,
  userGoals,
  goalComments,
  leaderboardUser,
  myGoals,
  myTournaments,
  myClubs,
  myLeagues,
  globalSearch,
  professionalTournament,
  banners,
  bannersCategories,
  homeBanners,
  homeBannerCategories,
  homeBannerChooser,
  competitions,
  competitionsList,
  advertisements,
  notifications,
  goalCategories,
  goalCategoriesAdmin,
  youtubeLinks,
  carousel,
  features,
  userVote,
  allClubs,
  allAdminClub,
  allAdminLeague,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET") {
    state = undefined; // Reset state to initial values
  }
  return appReducer(state, action);
};

export default rootReducer;
